import React from "react";

// Shared utilities
import { 
    OmniIconComponent, OmniTooltipNextComponent,OmniCheckboxComponent
} from "../../../../shared/components/omni-components";
import { 
    Utils,
} from "../../../../shared";
import { FilterCampaign } from '../CampaignTable/campaign-filter';
import { AlertMessagesService, MediaOpsService, trackEvent, OmniSearchComponent } from '../../../../shared';
export class MergeCampaignsPanel extends React.Component {
    nodeRef = [];
    holdDragItems = {};
    // Default state for the component
    defaultState = {
        dragItems: this.props.unMapCampaign || [],
        selectedUnmapCampaign: [],
        selectedUnmapCampaignIndex: [],
    }
    constructor(props) {
        super(props);
        let dragItems = props.unMapCampaign || [];
        dragItems.map((item) => {
            item.isChecked = false;
        })
        this.state = {...this.defaultState,dragItems};
    }


    /**
     * React lifecycle method called after the component is mounted.
     * Initializes state variables based on the parentCampaign and unMapCampaign props.
     */
    componentDidUpdate(prevProps) {
        if (prevProps.unMapCampaign.length !== this.props.unMapCampaign.length) {
            let dragItems = this.props.unMapCampaign || [];
            dragItems.map((item) => {
                item.isChecked = false;
            })
            this.setState({
                selectedUnmapCampaign: [],
                selectedUnmapCampaignIndex: [],
                dragItems
            });
        }
    }

    /**
     * Copies the given text to the clipboard and shows a success alert.
     * @param {string} text
     */
    copyToClipboard = (text) => {
        if (!navigator.clipboard?.writeText) {
            AlertMessagesService.showErrorToastMessage('Failed to copy campaign name');
            return;
        }
        navigator.clipboard.writeText(text).then(() => {
            AlertMessagesService.showSuccessToastMessage('Campaign name copied to clipboard');
        }).catch(() => {
            AlertMessagesService.showErrorToastMessage('Failed to copy campaign name');
        });
    }

    /**
     * drag start is function will send selected or draged unmapcampagin to transfer event in json format
     * if checkbox is selected then it will send array of ummapcampagin
     * if checkbox not selected then send on one camapgin in side array
     * Index sending to delete already merged unmapcampagin from list.
     * @param {object} event 
     * @param {object} item 
     * @param {number} index 
     */
    dragStart = (event,item,index) => {
        let listItems = [];
        let listItemsIndex  = [];
        let selectedUnmapCampaign = this.state.selectedUnmapCampaign;
        if(selectedUnmapCampaign.length > 0){
            listItems = selectedUnmapCampaign;
            listItemsIndex = this.state.selectedUnmapCampaignIndex;
        }else{
            listItems = [item];
            listItemsIndex = [index];
        }
        
        this.holdDragItems = {
            items : listItems,
            indexs : listItemsIndex
        };
        const dragData = {
            items: listItems,
            indexs : listItemsIndex
        }
        const jsonData = JSON.stringify(dragData);

        event.dataTransfer.setData("application/json", jsonData);
    };

    /**
     * create content from unmapp campagin 
     * @returns html of drag cards
     */
    createDragableContent = () => {
        return this.state?.dragItems?.map((item, index) => {
            let budget = 0;
            // item.isChecked = false;
            if (this.props?.systemParametersData?.data?.isLocal && item?.local_currency_name) {
                budget = Utils.getLocalCurrency(item?.local_currency_name, item?.campaign_total_budget);
            } else {
                budget = Utils.getLocalCurrency('USD', item?.campaign_total_budget);
            }
            const channels = item?.media_attributes?.channels ?? [];
            const channel = channels.map(ch => ch.channel_name).join(", ");
            return (
                <div className="mapping-item-card-container inner-col factory-panel" onDragStart={(e) => this.dragStart(e, item, index)} draggable="true" key={index}>
                    <div className="mapping-item-card">
                        <div className="mapping-left">
                            <div className="drag-handle" title="Drag">
                                <OmniIconComponent className="is-size-2" icon-id="omni:interactive:reorder"></OmniIconComponent>
                            </div>
                            <div className="channel-icon">
                                {/* <OmniIconComponent className="is-size-2" icon-id={'omni:informative:assets'} /> */}
                                <OmniCheckboxComponent id={`unmapCampaign-${index}`} name={`unmapCampaign-${index}`}
                                    checked={item.isChecked}
                                    onCheckboxChange={(event) => this.onDataChange(event, item, index)}>
                                </OmniCheckboxComponent>
                            </div>
                            <div className="channel-icon" onClick={() => this.openAndCloseModal('open', item)}>
                                <OmniIconComponent className="is-size-2" icon-id="omni:informative:error" ></OmniIconComponent>
                            </div>
                            <div
                                className="channel-icon"
                                onClick={() => this.copyToClipboard(item.campaign_name)}
                                aria-label="Copy campaign name to clipboard"
                            >
                                <OmniIconComponent className="is-size-2" icon-id="omni:interactive:copy"></OmniIconComponent>
                            </div>
                        </div>
                        <div className="mapping-center">
                            <div className="mapping-title">{item.campaign_name}</div>
                            <div className="mapping-meta">{item.client_code}|{item.client_name}</div>
                            <div className="mapping-meta">{item.start_date ? Utils.formatDateObject(item.start_date) : ''} {item.end_date ? ' - ' + Utils.formatDateObject(item.end_date) : ''}</div>
                            <div className="mapping-meta">{channel}</div>
                        </div>
                        <div className="mapping-right">
                            <div className="mapping-synthetic">{item.synthetic_id}</div>
                            <div className="mapping-price ordered">{budget}</div>
                            {/* <div className="mapping-price planned">{}</div> */}
                        </div>
                    </div>
                </div>
            )
        });
    }

    /**
     * user check or uncheck box the it hold checked unmapcampaign to send selected campagin
     * @param {object} event 
     * @param {object} item 
     * @param {number} index 
     */
    onDataChange = (event, item,index) => {
        let dragItems = structuredClone(this.state?.dragItems);
        dragItems[index].isChecked = event.target.checked;
        let selectedUnmapCampaign = structuredClone(this.state.selectedUnmapCampaign);
        let selectedUnmapCampaignIndex = structuredClone(this.state.selectedUnmapCampaignIndex);
        if(event.target.checked){
            selectedUnmapCampaign.push(item);
            selectedUnmapCampaignIndex.push(index);
        }else{
            let unmapCampaignIndex = selectedUnmapCampaign.findIndex(campaign => campaign.synthetic_id === item.synthetic_id);
            if(unmapCampaignIndex !== -1){
                selectedUnmapCampaign.splice(unmapCampaignIndex, 1);
                selectedUnmapCampaignIndex.splice(unmapCampaignIndex, 1);
            }
        }
        this.setState({selectedUnmapCampaign, selectedUnmapCampaignIndex,dragItems});
    }

    /**
     * function use to close popu modal of campagin that appare when click on info ican
     * @param {string} status 
     * @param {object} item 
     */
    openAndCloseModal = (status,item = {}) => {
        const modal = document.getElementById('mappingModal');
        if (modal) {
            if(status === 'close'){
                modal.close(); 
            }else{
                this.setState({ modalValues: item });
                modal.showModal();
            }
        }
    }

    /**
     * Function will filter out ther campaign as per filter Options and update the drag items to show in mapping panel
     * @param {Object} filterOptions 
     * @param {boolean} clearAll 
     */
    applyFilter = (filterOptions,clearAll=false) => {
        const unMapCampaign = this.props.unMapCampaign || [];
        let dragItems = [];
        if(clearAll){
            dragItems = unMapCampaign;
        }else{
            dragItems = unMapCampaign.filter((campaign) => {
                // Filter by campaign name
                if (filterOptions.campaignName && !campaign.campaign_name?.toLowerCase().includes(filterOptions.campaignName.toLowerCase())) {
                    return false;
                }
                // Filter by client code
                if (filterOptions.clientCode && !campaign.client_code?.toLowerCase().includes(filterOptions.clientCode.toLowerCase())) {
                    return false;
                }
                // Filter by product code
                if (filterOptions.productCode && !campaign.product_code?.toLowerCase().includes(filterOptions.productCode.toLowerCase())) {
                    return false;
                }
                // Filter by estimate code
                if (filterOptions.estimateCode && !campaign.estimate_code?.toLowerCase().includes(filterOptions.estimateCode.toLowerCase())) {
                    return false;
                }
                // Filter by start date
                if (filterOptions.startDate && campaign.start_date && new Date(campaign.start_date) < new Date(filterOptions.startDate)) {
                    return false;
                }
                // Filter by end date
                if (filterOptions.endDate && campaign.end_date && new Date(campaign.end_date) > new Date(filterOptions.endDate)) {
                    return false;
                }
                // Filter by ordered net media min
                if (filterOptions.orderedNetMediaMin && (campaign.ordered_budget || 0) < parseFloat(filterOptions.orderedNetMediaMin)) {
                    return false;
                }
                // Filter by ordered net media max
                if (filterOptions.orderedNetMediaMax && (campaign.ordered_budget || 0) > parseFloat(filterOptions.orderedNetMediaMax)) {
                    return false;
                }
                // Filter by planned net media min
                if (filterOptions.plannedNetMediaMin && (campaign.campaign_total_budget || 0) < parseFloat(filterOptions.plannedNetMediaMin)) {
                    return false;
                }
                // Filter by planned net media max
                if (filterOptions.plannedNetMediaMax && (campaign.campaign_total_budget || 0) > parseFloat(filterOptions.plannedNetMediaMax)) {
                    return false;
                }
                // Filter by status
                if (filterOptions.status && campaign.status?.toLowerCase() !== filterOptions.status.toLowerCase()) {
                    return false;
                }
                // Filter by type
                if (filterOptions.type && campaign.type?.toLowerCase() !== filterOptions.type.toLowerCase()) {
                    return false;
                }
                return true;
            });
        }
        dragItems.map((item) => {
                item.isChecked = false;
        });
        this.setState({dragItems});
    }
    /**
     * function will filter out campaigns based on search text from omni search component and update the drag items to show in mapping panel
     * @param {String} event 
     */
    updateSearch = (event) => {
        const searchText = event?.detail?.value || '';
        if(searchText && this.props.unMapCampaign){
            const unMapCampaign = this.props.unMapCampaign;
            let dragItems = unMapCampaign.filter((campaign) => 
                campaign.campaignName?.toLowerCase().includes(searchText.toLowerCase())
        );
        this.setState({dragItems});
        }else{
            this.setState({dragItems: this.props.unMapCampaign || []});
        }
    }
    render() {
        return (
            <>
                {this.props.isMappingTable && <div className="mergecampaign-container">
                    <div className="mapping-header">
                        <p>Mapping</p>
                        <div className="modal-close-icon"  onClick={() => this.props.setMappingTable(false)}>
                            <OmniIconComponent className="is-size-1" icon-id="omni:interactive:close"></OmniIconComponent>
                        </div>
                    </div>
                    <hr />
                    <div className="mapping-subheader">
                        <div className="subheader-text">
                            <span>{this.state?.dragItems?.length}</span>
                            <p>Campaign Orders</p>
                        </div>
                        <div className="subheader-actions ">
                            {/* <OmniIconComponent className="is-size-1 subheader-icon" icon-id="omni:interactive:search"></OmniIconComponent> */}
                            <OmniSearchComponent className="searchIcon search-input-icon" onSearchUpdate={this.updateSearch} slot="end" ph="Search"></OmniSearchComponent>
                            <FilterCampaign onApplyFilter={this.applyFilter.bind(this)} isTabRequired={false} id={'unmap-campaign'}/>
                            {/* <OmniIconComponent className="is-size-1 subheader-icon" icon-id="omni:interactive:funnel"></OmniIconComponent> */}
                            {/* <OmniIconComponent className="is-size-1 subheader-icon" icon-id="omni:informative:menu"></OmniIconComponent> */}
                        </div>
                    </div>
                    <div className="drag-container">
                        {this.state?.dragItems?.length ? this.createDragableContent() : 
                            <div className="no-data-container">
                                <div className="no-data-icon">
                                    <OmniIconComponent className="is-size-3 success-icon" icon-id="omni:informative:success"></OmniIconComponent>
                                </div>
                                <p className="no-data-title">Nice Job!</p>
                                <p className="no-data-subtitle">All your campaigns are mapped</p>
                            </div>
                        }
                    </div>
                    <omni-modal id="mappingModal">
                        <div slot="header">
                            <div className="mapping-header mapping-modal-header">
                                <p>Details</p>
                                <div className="modal-close-icon"  onClick={() => this.openAndCloseModal('close')}>
                                    <OmniIconComponent className="is-size-1" icon-id="omni:interactive:close"></OmniIconComponent>
                                </div>
                            </div>
                        </div>
                        <div className="modal-details" style={{ padding: '18px 20px' }}>
                            {/* Two-column label/value layout */}
                            {(() => {
                                const v = this.state?.modalValues || {};
                                const isLocal = this.props?.systemParametersData?.data?.isLocal;
                                const formatCurrency = (amount) => {
                                    if (isLocal && v?.local_currency_name) return Utils.getLocalCurrency(v.local_currency_name, amount || 0);
                                    return Utils.getLocalCurrency('USD', amount || 0);
                                }
                                const channels = v?.media_attributes?.channels?.map(c => c.channel_name).join(', ');
                                const dateRange = v?.start_date || v?.end_date ? `${v.start_date ? Utils.formatDateObject(v.start_date) : ''}${v.end_date ? ' - ' + Utils.formatDateObject(v.end_date) : ''}` : (v.campaign_date_range || '');

                                return (
                                    <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', rowGap: '12px', columnGap: '18px', alignItems: 'start' }}>
                                        <div style={{ color: '#6b7280' }}>Source:</div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <OmniIconComponent icon-id={"omni:object:campaign"} className="is-size-3" ></OmniIconComponent>
                                            <span>{v.source}</span>
                                        </div>

                                        <div style={{ color: '#6b7280' }}>Name:</div>
                                        <div style={{ color: '#111827', fontWeight: 500 }}>{v.campaign_name || v.name || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Prisma ID:</div>
                                        <div style={{ color: '#111827' }}>{v.synthetic_id || v.prisma_id || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Date Range:</div>
                                        <div style={{ color: '#111827' }}>{dateRange || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Channel(s):</div>
                                        <div style={{ color: '#111827' }}>{channels || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Ordered:</div>
                                        <div style={{ color: '#111827' }}>{formatCurrency(v.ordered_budget || v.ordered || v.ordered_amount)}</div>

                                        <div style={{ color: '#6b7280' }}>Planned:</div>
                                        <div style={{ color: '#111827' }}>{formatCurrency(v.planned_budget || v.planned || v.campaign_total_budget)}</div>

                                        <div style={{ color: '#6b7280' }}>Client Code:</div>
                                        <div style={{ color: '#111827' }}>{v.client_code || v.client || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Product Code:</div>
                                        <div style={{ color: '#111827' }}>{v.product_code || v.product || '-'}</div>
                                    </div>
                                )
                            })()}
                        </div>
                    </omni-modal>
                </div>
                }       
            </>
        );
    }

}